export default __webpack_public_path__ + "static/media/onboarding_5.e271e830.png";